import { useState } from "react";
import Button from "../../ui/Button";
import Modal, { ModalBody, ModalFooter, ModalFooterChild, ModalHeader } from "../../ui/Modal";
import Card, { CardBody } from "../../ui/Card";
import AddMachineForm from "../addMachine/addMachineForm";
import AddAdminMachineForm from "../addMachine/addAdminMachineForm";

const AddMachineModel = ({
  editMachineInfo,
  handleResetPagination,
  modalStatus,
  setModalStatus,
  handleCloseMachinePopUp,
}) => {
  return (
    <>
      <Modal
        isOpen={modalStatus}
        setIsOpen={setModalStatus}
        isAnimation={true}
        isCentered={true}
        isScrollable={true}
        isStaticBackdrop={"rounded-3xl"}
        size={"lg"}
      >
        <ModalHeader>LIST YOUR MACHINE</ModalHeader>
        <ModalBody>
          <div>
            <AddAdminMachineForm
              handleCloseMachinePopUp={handleCloseMachinePopUp}
              handleResetPagination={handleResetPagination}
              editMachineInfo={editMachineInfo}
            />
          </div>
        </ModalBody>
        {/* <ModalFooter>
          <ModalFooterChild></ModalFooterChild>
          <ModalFooterChild>
            <Button variant="solid" onClick={() => setModalStatus(false)}>
              Close
            </Button>
          </ModalFooterChild>
        </ModalFooter> */}
      </Modal>
    </>
  );
};
export default AddMachineModel;
